import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.some.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "el-upload__tip"
};
import { ElNotification } from 'element-plus';
import 'element-plus/es/components/notification/style/css'

import ExcelErrorDialog from './excel/error-dialog.vue';
import XUpload from '../x-upload/XUpload.vue';

import { ref, computed, watch } from 'vue';
const KB = 1024;
export default /*@__PURE__*/_defineComponent({
  __name: 'UploadContainer',
  props: {
    action: {
      type: String,
      required: true
    },
    value: {
      type: Object,
      default: () => ({})
    },
    multiple: {
      type: Boolean,
      default: false
    },
    autoUpload: {
      type: Boolean,
      default: false
    },
    accept: {
      type: Array,
      default: () => ['.xls', '.xlsx']
    },
    limit: {
      type: Number,
      default: 1
    },
    maxSize: {
      type: Number,
      default: 1024 * 1024 * 100
    },
    resultHandler: Function,
    errorHandler: Function,
    exportBaseUrl: {
      type: String,
      default: ''
    },
    beforeUpload: Function
  },
  emits: ['importStart', 'importEnd', 'importSuccess', 'importError'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const M = KB * 1024;
    const props = __props;
    const emits = __emit;
    const upload = ref({
      fileList: [],
      uploading: false
    });
    const uploader = ref();
    const errorDialogInstance = ref();
    const getAccepts = computed(() => props.accept.length > 0 ? props.accept.join(',') : '*');
    const getExtensions = computed(() => props.accept.length > 0 ? props.accept.join('、') : '*');
    const getLimitation = computed(() => {
      if (props.maxSize >= 1 * M) {
        return props.maxSize / (1 * M) + 'MB';
      }
      if (props.maxSize >= 1 * KB) {
        return props.maxSize / (1 * KB) + 'KB';
      }
      return props.maxSize + 'B';
    });
    const getTip = computed(() => {
      const extensions = getExtensions.value;
      const limitation = getLimitation.value;
      if (extensions && !limitation) {
        return `可以上传${extensions}类型的文件。`;
      }
      if (!extensions && limitation) {
        return `文件大小不能超过${limitation}。`;
      }
      if (extensions && limitation) {
        return `可以上传${extensions}类型的文件，且文件大小不能超过${limitation}。`;
      }
      return '';
    });
    watch(() => upload.value.uploading, newVal => {
      newVal ? emits('importStart') : emits('importEnd');
    });
    function submit() {
      uploader.value?.submit();
    }
    function reset() {
      upload.value.fileList = [];
      upload.value.uploading = false;
    }
    function uploadCallback(promise) {
      upload.value.uploading = true;
      promise.then(res => {
        upload.value.uploading = false;
        if (props.resultHandler) {
          props.resultHandler(res);
          return;
        }
        const result = res.data;
        const sheetImportResults = result.sheetImportResults;
        if (sheetImportResults && sheetImportResults.length > 0) {
          const error = sheetImportResults.some(r => r.cellErrors && r.cellErrors.length > 0);
          if (error) {
            emits('importError', result);
            errorDialogInstance.value?.show(result);
          } else {
            emits('importSuccess', result);
          }
        } else {
          console.info(result);
          ElNotification({
            type: 'error',
            message: '导入结果异常'
          });
        }
      }).catch(e => {
        if (props.errorHandler) {
          props.errorHandler(e);
          return;
        }
        console.error(e);
        const res = e.response;
        ElNotification({
          type: 'error',
          message: res?.data?.message || '导入失败，未知的错误'
        });
      }).finally(() => {
        upload.value.uploading = false;
      });
    }
    function doBeforeUpload(files, data) {
      if (!files || files.length < 1) {
        ElNotification({
          type: 'warning',
          message: '请选择需要导入的文件'
        });
        return false;
      }
      if (props.maxSize) {
        let size = 0;
        for (const file of files) {
          size += file.size;
        }
        if (size > props.maxSize) {
          ElNotification({
            type: 'warning',
            message: `文件大小不能超过${getLimitation.value}`
          });
          return false;
        }
      }
      return !props.beforeUpload || !!props.beforeUpload(files, data);
    }
    function handleChange(files, fileList) {
      if (!fileList) {
        return;
      }
      if (props.limit === 1) {
        if (fileList.length > 1) {
          upload.value.fileList = fileList.slice(-1);
        }
      } else {
        if (fileList.length > props.limit) {
          ElNotification({
            type: 'warning',
            message: `最多只能上传${props.limit}个文件`
          });
          upload.value.fileList = fileList.slice(0, fileList.length - 1);
        }
      }
    }
    function handleFileModified(file) {
      ElNotification({
        type: 'warning',
        message: `文件 ${file.name} 已修改，请重新选择此文件`
      });
    }
    __expose({
      submit,
      reset
    });
    return (_ctx, _cache) => {
      const _component_upload_filled = _resolveComponent("upload-filled");
      const _component_el_icon = _resolveComponent("el-icon");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(XUpload, {
        ref_key: "uploader",
        ref: uploader,
        class: "uploader",
        action: __props.action,
        callback: uploadCallback,
        accept: _unref(getAccepts),
        "auto-upload": __props.autoUpload,
        multiple: __props.multiple,
        value: __props.value,
        "file-list": _unref(upload).fileList,
        "on-change": handleChange,
        disabled: _unref(upload).uploading,
        "before-upload": doBeforeUpload,
        "on-modified": handleFileModified,
        limit: __props.limit
      }, {
        tip: _withCtx(() => [_createElementVNode("div", _hoisted_1, _toDisplayString(_unref(getTip)), 1)]),
        default: _withCtx(() => [_createVNode(_component_el_icon, {
          class: "el-icon--upload"
        }, {
          default: _withCtx(() => [_createVNode(_component_upload_filled)]),
          _: 1
        }), _cache[0] || (_cache[0] = _createElementVNode("div", {
          class: "el-upload__text"
        }, [_createTextVNode("将文件拖到此处，或"), _createElementVNode("em", null, "点击上传")], -1))]),
        _: 1
      }, 8, ["action", "accept", "auto-upload", "multiple", "value", "file-list", "disabled", "limit"]), _createVNode(ExcelErrorDialog, {
        ref_key: "errorDialogInstance",
        ref: errorDialogInstance,
        title: "导入失败",
        width: "30%",
        exportBaseUrl: __props.exportBaseUrl,
        "append-to-body": true
      }, null, 8, ["exportBaseUrl"])]);
    };
  }
});